import { render, staticRenderFns } from "./SustainabilityIndicators.vue?vue&type=template&id=cd79bcf2"
import script from "./SustainabilityIndicators.vue?vue&type=script&lang=js"
export * from "./SustainabilityIndicators.vue?vue&type=script&lang=js"
import style0 from "./SustainabilityIndicators.vue?vue&type=style&index=0&id=cd79bcf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports